import axios from 'configs/http';

export const sendSms = datas => axios.post('/api/practice/customer/sendVerifyCode', datas);

export const register = datas => axios.post('/api/practice/customer/register', datas);

export const login = datas => axios.post('/api/practice/customer/login', datas);

export const getUserInfo = () => axios.get('/api/practice/customer/getUserInfo');

// eslint-disable-next-line object-curly-spacing
export const bindWeixinInfo = code => axios.get('/api/practice/customer/bindWeiXinInfo', { params: { code } });

export const getAccountInfo = () => axios.get('/api/account/getAccountInfo');
